<template>
  <div>
    <slot
    :results="results"
    :filters="filters"
    :processresults="processResults"
    :event="event"
    :searchProxy="searchProxy"
    :updateSearch="updateSearch"
    :featuredBlocks="featuredBlocks"
    :showFeature="showFeature",
    :searchReact="searchReact"
    />
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, watchEffect, watch } from 'vue';
import { cloneDeep, flatten, uniqBy, groupBy, sortBy } from 'lodash';
import Fuse from 'fuse.js';
import { getPerformances } from '../services/inventory';
import zonedDate from '../utils/zoned-date';

export default defineComponent({
  name: 'WhatsOnEvents',
  props: {
    blocks: {
        type: Array,
        default: [],
    }
  },
  setup(props) {
    const search = ref('');
    const results = ref([]);
    const filters = ref([]);
    const event = ref({});
    const performances = ref([]);
    const fuse = ref(null);
    const bannerInserted = ref(false);

    const featuredBlocks = ref([]);
    const FEATURE_BLOCK = 'featured-highlight';


    const setupFeaturedBlocks = (blocks) => {
        const groupedFeatures = groupBy(blocks, block => block.blockType);
        featuredBlocks.value = groupedFeatures[FEATURE_BLOCK];
    }

    const showFeature = (index) => {
        if ((index + 1) === 6) {
            return true;
        }

        return false;
    }

    const searchReact = (event) => {
        search.value = event;

        processResults();
    }

    watch(
        () => props.blocks,
        (newBlocks) => {
            //item.value = newItem;
            console.log('Blocks: ', newBlocks)
            setupFeaturedBlocks(newBlocks)
        },
        { immediate: true }
    );

    const setupFilters = () => {
      let aggregatedFilters = [
        { title: 'Events', field: 'events_filters', facets: [] },
        { title: 'Event Type', field: 'event_type_filters', facets: [] },
      ];

      aggregatedFilters = aggregatedFilters.map(filter => {
        let facets = performances.value.map(item =>
          cloneDeep(item.filters[filter.field] || []));
        facets = flatten(facets);
        facets = uniqBy(facets, facet => facet.title);
        filter.facets = facets.map(facet => ({
          ...facet,
          is_checked: false,
          is_disabled: false,
        }));
        return filter;
      });

      filters.value = aggregatedFilters;
    };

    const processResults = () => {
      console.log('📦 processResults called with search:', search.value);

      const andQuery = [];

      for (const filter of filters.value) {
        const orQuery = [];
        for (const facet of filter.facets) {
          if (facet.is_checked) {
            orQuery.push({
              [`filters.${filter.field}.title`]: facet.title,
            });
          }
        }
        if (orQuery.length) {
          andQuery.push({ $or: orQuery });
        }
      }

      let filteredResults = performances.value;

      if (search.value && search.value.trim() !== '') {
        const searchTerm = search.value.trim().toLowerCase();
        filteredResults = filteredResults.filter(item =>
          (item.title && item.title.toLowerCase().includes(searchTerm)) ||
          (item.event?.title && item.event.title.toLowerCase().includes(searchTerm))
        );
      }

      if (andQuery.length && fuse.value) {
        filteredResults = fuse.value.search({ $and: andQuery }).map(r => r.item);
      }

      results.value = sortBy(filteredResults, item => {
        return zonedDate(+item.startDate);
      });
    };

    onMounted(async () => {
      performances.value = await getPerformances();

      setupFilters();

      fuse.value = new Fuse(performances.value, {
        threshold: 0.25,
        useExtendedSearch: true,
        includeScore: false,
        shouldSort: false,
        keys: [
          'filters.events_filters.title',
          'filters.event_type_filters.title',
        ],
      });

      processResults();
    });

    // Watch search input and reactively update results (tried to use this for debugging the search)
    watchEffect(() => {
      console.log('🔁 search changed:', search.value);
      processResults();
    });

    const searchProxy = {
        get value() {
            return search.value;
        },
        set value(val) {
            console.log('📝 searchProxy set to:', val);
            search.value = val;
        }
    };

    const updateSearch = (val) => {
        search.value = val;
    };

    return {
        results,
        filters,
        processResults,
        event,
        search,
        searchProxy,
        updateSearch,
        bannerInserted,
        featuredBlocks,
        showFeature,
        searchReact
    };
  },
});
</script>